import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

// Components
import ServiceAreasPage from './pages/ServiceAreasPage'
import ThankYouPage from './pages/ThankYouPage'

// Components
import ScrollToTop from './components/ScrollToTop'
import { BookingProvider } from './components/BookingModal'
import AutoPopup from './components/AutoPopup'

// Pages
import HomePage from './pages/HomePage'
import ServicesPage from './pages/ServicesPage'
import ServiceDetailPage from './pages/ServiceDetailPage'
import AboutPage from './pages/AboutPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import ContactPage from './pages/ContactPage'

function App() {
  return (
    <BookingProvider>
      <AutoPopup />
      <div className="App">
        <ScrollToTop />
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#333',
              color: '#fff',
              borderRadius: '12px',
            },
          }}
        />
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/service-areas/:slug" element={<ServiceAreasPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />

          {/* 404 - Fallback to Home */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </BookingProvider>
  )
}

export default App
